// you can import modules from the theme lib or even from
// NPM packages if they support it…

// Some convenient tools to get you started…
// import importFileName from "./components/importFileName";

import isotope from "./vendor/isotope.pkgd.js";

import 'jquery-background-video';
import 'jquery-match-height';
import 'alpinejs';
import 'flickity';
import 'flickity-imagesloaded';

import AOS from 'aos';
import paroller from 'paroller.js';
import lazy from 'jquery-lazy';
import mixitup from 'mixitup';

import lightgallery from 'lightgallery';
import lgthumbnails from 'lg-thumbnail';
import lgautoplay from 'lg-autoplay';
import lgfullscreen from 'lg-fullscreen';
// import lghash from 'lg-hash';
import lgpager from 'lg-pager';
// import lgrotate from 'lg-rotate';
// import lgshare from 'lg-share';
import lgvideo from 'lg-video';
import lgzoom from 'lg-zoom';

var Flickity = require('flickity');

    // Flickity.prototype._createResizeClass = function() {
    //     this.element.classList.add('flickity-resize');
    // };
    
    // Flickity.createMethods.push('_createResizeClass');
    
    // var resize = Flickity.prototype.resize;
    // Flickity.prototype.resize = function() {
    //     this.element.classList.remove('flickity-resize');
    //     resize.call( this );
    //     this.element.classList.add('flickity-resize');
    // };

// Masonry JS scripts
jQuery(window).on('load', function() {
    // the scroll to top 
    var mybutton = document.getElementById("scrollToTop");
    if(mybutton){
        mybutton.addEventListener("click", topFunction);

        // When the user scrolls down 20px from the top of the document, show the button
        window.onscroll = function() {
            scrollFunction()
        };
        function scrollFunction() {
        if (document.body.scrollTop > 35 || document.documentElement.scrollTop > 35) {
            mybutton.classList.remove("invisible");
            mybutton.classList.add("visible");
        } else {
            mybutton.classList.remove("visible");
            mybutton.classList.add("invisible");
            
        }
        }
        // When the user clicks on the button, scroll to the top of the document
        function topFunction() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
    }
    
    
    if (jQuery('.iso-grid').length){
        var $masonry = jQuery('.iso-grid').isotope({
            itemSelector: '.iso-item',
            columnWidth: '.iso-item',
            transitionDuration: 0
        });
    }

    if (jQuery('#lightgallery').length){
		jQuery('#lightgallery').lightGallery({
		    mode: 'lg-fade',
		    cssEasing: 'cubic-bezier(0.25, 0, 0.25, 1)',
		    selector: '.lightgallery-item',
		    hash: false,
		    download: true,
            thumbnail:true,
            subHtmlSelectorRelative: true,
            loadYoutubeThumbnail: true,
            youtubeThumbSize: 'default',

		});
	}

    if (jQuery('#videogallery').length){
		jQuery('#videogallery').lightGallery({
		    mode: 'lg-fade',
		    cssEasing: 'cubic-bezier(0.25, 0, 0.25, 1)',
            selector: '.videogallery-item',
            loadYoutubeThumbnail: true,
            youtubeThumbSize: 'default',
		});
	}
});


// Initialise our components on jQuery.ready…
jQuery( document ).ready(function($) {

    $('.my-paroller').paroller();  

    // AOS.init({
    //     offset: 200, // offset (in px) from the original trigger point
    //     delay: 50, // values from 0 to 3000, with step 50ms
    //     duration: 750, // values from 0 to 3000, with step 50ms
    //     easing: 'ease', // default easing for AOS animations
    //     once: false, // whether animation should happen only once - while scrolling down
    //     mirror: false, // whether elements should animate out while scrolling past them
    //     anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    // });

    $('.lazy').Lazy({
        // your configuration goes here
        effect: "fadeIn",
        effectTime: 500,
        threshold: 0,
        scrollDirection: 'both',
    });

    function openLgMenuOn() {
        $("html, body").addClass("menu-lg-open");
    }
    function openLgMenuOff() {
        $("html, body").removeClass("menu-lg-open");
    }

    function openSmMenu() {
        $("html, body").toggleClass("menu-sm-open");
    }

    function toggleOverlayOn() {
        $("html, body").addClass("overlay-open");
        $(".menu-overlay").removeClass("invisible opacity-0");
        $(".menu-overlay").addClass("visible opacity-100");
    }
    function toggleOverlayOff() {
        $("html, body").removeClass("overlay-open");
        $(".menu-overlay").removeClass("visible opacity-100");
        $(".menu-overlay").addClass("invisible opacity-0");
    }

    function menuFadeIn() {
        $(".nav-child").addClass("opacity-100 visible");
        $(".nav-child").removeClass("opacity-0 invisible");
    }
    function menuFadeOut() {
        $(".nav-child").removeClass("opacity-100 visible");    
        $(".nav-child").addClass("opacity-0 invisible");

    }

    function toggleMenu(){
        $("#menu-wrapper").toggleClass("hidden flex");
    }

    // this applies when you click a menu item with children, on the DESKTOP menu 
    $('.nav.nav-0 ul li.menu-item-has-children a').on('click', function(){
        if (window.innerWidth > 1023) {
            toggleOverlayOn();
            openLgMenuOn();
        }
        setTimeout(menuFadeIn, 0);
    })

    jQuery(".nav-child").addClass('opacity-0 invisible');

    // this applies when you click a menu item with children, on the DESKTOP menu 
    $('.menu-overlay').on('click', function(){
        toggleOverlayOff();
        openLgMenuOff();
        setTimeout(menuFadeOut, 0);
    })

    $('.open-sm-menu').on('click', function(){
        // toggleOverlay();
        openSmMenu();
        $(".hamburger").toggleClass("is-active");
        setTimeout(toggleMenu, 400)
    })

    $(document).on('mousemove', (event) => {
        $('.mouse-follower').css({
            left: event.clientX,
            top: event.clientY,
        });
    });

    // refreshes the window at lg width so that theres no conflict in menu
    var ww = $(window).width();
    var limit = 1024;

    function refresh() {
        ww = $(window).width();
        var w =  ww<limit ? (location.reload(true)) :  ( ww>limit ? (location.reload(true)) : ww=limit );
    }

    var tOut;
    $(window).resize(function() {
        var resW = $(window).width();
        clearTimeout(tOut);
        if ( (ww>limit && resW<limit) || (ww<limit && resW>limit) ) {        
            tOut = setTimeout(refresh, 100);
        }
    });

    // course registration form toggle

    $('#toggle_registration').on('click', function(){
        $("#form-registration").removeClass('hidden');

    });



    // var mixer = mixitup('.mix-grid', {
    //     selectors: {
    //         target: '.mix-item'
    //     },
    //     animation: {
    //         duration: 300,
    //     },
    // });

    // URL Hash for the mixitup

    var targetSelector = '.mix-item';
    var containerEl = document.querySelector('.mix-grid');

    /**
     * Reads a hash from the URL (if present), and converts it into a class
     * selector string. E.g "#green" -> ".green". Otherwise, defaults
     * to the targetSelector, equivalent to "all"
     *
     * @return {string}
     */

    function getSelectorFromHash() {
        var hash = window.location.hash.replace(/^#/g, '');

        var selector = hash ? '.' + hash : targetSelector;

        return selector;
    }

    /**
     * Updates the URL whenever the current filter changes.
     *
     * @param   {mixitup.State} state
     * @return  {void}
     */

    function setHash(state) {
        var selector = state.activeFilter.selector;
        var newHash = '#' + selector.replace(/^\./g, '');

        if (selector === targetSelector && window.location.hash) {
            // Equivalent to filter "all", remove the hash

            history.pushState(null, document.title, window.location.pathname); // or history.replaceState()
        } else if (newHash !== window.location.hash && selector !== targetSelector) {
            // Change the hash

            history.pushState(null, document.title, window.location.pathname + newHash); // or history.replaceState()
        }
    }
    
    // on events page, fires the upcoming events first
    if ( $( "#events-mixitup" ).length ) {
        if (containerEl) {
            var mixer = mixitup(containerEl, {
                selectors: {
                    target: targetSelector
                },
                animation: {
                    duration: 300,
                },
                load: {
                    filter: '.event-upcoming',
                },
                callbacks: {
                    onMixEnd: setHash // Call the setHash() method at the end of each operation
                }
            });
        };
    }

    // Instantiate and configure the mixer
    if (containerEl) {
        var mixer = mixitup(containerEl, {
            selectors: {
                target: targetSelector
            },
            animation: {
                duration: 300,
            },
            load: {
                filter: getSelectorFromHash() // Ensure that the mixer's initial filter matches the URL on startup
            },
            callbacks: {
                onMixEnd: setHash // Call the setHash() method at the end of each operation
            }
        });
    };

    // Add an "onhashchange" handler to keep the mixer in sync as the user goes
    // back and forward through their history.

    // NB: This may or may not be the desired behavior for your project. If you don't
    // want MixItUp operations to count as individual history items, simply use
    // 'replaceState()' instead of 'pushState()' within the 'setHash()' function above.
    // In which case this handler would no longer be neccessary.

    window.onhashchange = function() {
        var selector = getSelectorFromHash();
        if (selector === mixer.getState().activeFilter.selector) return; // no change
        mixer.filter(selector);
    };
      
});

